import moment from 'moment';
import React from 'react';

const Message = ({ message }) => {
  return (
    <>
      <div className={`chat-message ${message.sender}`}>
        <span>{message.text}</span>

        <span className='chat-time'>{moment(message.timestamp).fromNow()}</span>
      </div>
      <div
        style={{
          display: 'flex',
          gap: 16,
          flexWrap: 'wrap',
          rowGap: 16,
          justifyContent:
            message.sender === 'manager' ? 'flex-end' : 'flex-start',
        }}
      >
        {message.photos && message.photos.length > 0 && (
          <div className='message-photos'>
            {message.photos.map((photoUrl, index) => (
              <img
                key={index}
                src={photoUrl}
                alt={`Message attachment ${index + 1}`}
                style={{
                  maxWidth: '100%',
                  maxHeight: '200px',
                  borderRadius: '8px',
                  margin: '8px 0',
                }}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Message;
